import { createRoot } from 'react-dom/client'
import './index.css'
import { initSentry, Sentry } from '@/lib/sentry'
import { initPostHog } from '@/lib/posthog'
import App from './App.tsx'
import { ToastProvider } from '@/components/use-toast'
import { ConfirmProvider } from '@/components/use-confirm'
import { TooltipProvider } from '@/components/ui/tooltip'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { installStaleChunkReload } from '@/lib/stale-chunk'

// Initialize error tracking + product analytics before anything renders.
initSentry()
initPostHog()
// After a deploy renames the lazy page files, reload once instead of crashing.
installStaleChunkReload()

// StrictMode intentionally double-invokes renders in development which
// surfaces as flicker. We keep components safe but skip the wrapper.
//
// TooltipProvider lives at the app root with a 300ms delay so all icon
// buttons share one group — hovering one tooltip primes the next.
createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary
    fallback={
      <div
        role="alert"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          fontFamily: 'Inter, system-ui, sans-serif',
          color: '#475569',
        }}
      >
        <p style={{ fontSize: 18, fontWeight: 600, color: '#0f172a' }}>
          Something went wrong
        </p>
        <p style={{ fontSize: 14 }}>The error has been reported. Please reload the page.</p>
        <button
          type="button"
          onClick={() => window.location.assign('/')}
          style={{
            padding: '8px 16px',
            borderRadius: 8,
            background: '#6366f1',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          Reload
        </button>
      </div>
    }
  >
    <ThemeProvider>
      <ToastProvider>
        <ConfirmProvider>
          <TooltipProvider delayDuration={300}>
            <App />
          </TooltipProvider>
        </ConfirmProvider>
      </ToastProvider>
    </ThemeProvider>
  </Sentry.ErrorBoundary>,
)
